const imagingProcessor=(element)=>
{
const whichCancer =
    {
    "Chest XR suggesting lung cancer": "lung cancer",
    "Chest XR suggesting pleural disease": "pleural disease",
    "Ultrasound / CT suspicious of ovarian cancer": "ovarian cancer",
    "Ultrasound / CT suspicious of endometrial cancer": "endometerial carcinoma",
    "X Ray suggesting bone sarcoma": "bone sarcoma",
    "Ultrasound suggesting / inconclusive for sarcoma": "bone sarcoma",
    "usSarcoma": "sarcoma"
    }

let assembledElement = ""

switch (element["Type_of_imaging:"]) {
    case "X Ray":
        assembledElement += " an X ray"        
        break;

    case "Ultrasound":
        assembledElement += " an ultrasound scan"        
        break;

    case "CT":
        assembledElement += " a CT scan"        
        break;

    case "MRI":
        assembledElement += " an MRI scan"        
        break;
    
    case "Nuclear medicine":
        assembledElement += " nuclear medicine imaging"        
        break;
    
    default:
        assembledElement += " imaging" 
        break;
}

if (element["Date_of_imaging"] !== "")
    {
    let testDate = new Date (element["Date_of_imaging"])
    let testDateString = testDate.toLocaleDateString()
    assembledElement += ` on ${testDateString}`
    }

 if (element["Hospital_where_imaging_performed:"] !== "")
    {
    assembledElement += ` at ${element["Hospital_where_imaging_performed:"]}`
    }

assembledElement += " which"

switch (element["Cancer_on_imaging:"]) {
    case "Strong probability of cancer":
    assembledElement += " showed a strong probablility of"
    break;

    case "Possibility of cancer":
    assembledElement += " showed a possibility of"
    break;

    case "Can't exclude cancer":
    assembledElement += " could not exclude"
    break;

    case "No suspicion of cancer":
    assembledElement += " did not suggest"
    break;

    default:
    assembledElement += " showed suspicion of"
    break;
    }

assembledElement += ` ${whichCancer[(element["symptom"])]}`

if (element["Summary_of_findings"] !== "")
    {
    assembledElement += ` with findings reported as ${element["Summary_of_findings"]}`
    }

    
return (assembledElement)
}

export default imagingProcessor
